//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { APP_DATE_DOT_FORMAT } from "@/assets/js/appConfig";
import {
    downloadErrorCode,
    copyToClipboard,
    convertAndFormatTimeToLocal
} from "@/assets/js/appFunc";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQMenu from "@/components/Generics/AQMenu/AQMenu.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQListBtn from "@/components/Generics/AQButtonsList/AQButtonsList.vue";

export default {
    components: {
        AQCard,
        AQMenu,
        AQButton,
        AQInput,
        AQListBtn
    },
    props: {
        mode: {
            type: String,
            default: "sum", // application summary, b - api modal
            validator: v => ["sum", "api"].includes(v.toLowerCase())
        },
        api: {
            type: Object,
            default: () => {}
        },
        isArchiving: {
            type: Boolean,
            default: false
        },
        processInspectorDescriptionById: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            optionsMenuError: [
                {
                    value: "copy",
                    label: this.$t("admin.processInspector.copy")
                },
                {
                    value: "download",
                    label: this.$t("admin.processInspector.download")
                }
            ],
            showPopup: [],
            hideListBtns: ["edit", "more", "delete", "download"]
        };
    },
    computed: {
        showError() {
            return this.mode === "sum" ? this.processInspectorDescriptionById.stackTrace : this.api.error;
        },
        showTraceId() {
            return this.mode === "sum" ? this.processInspectorDescriptionById.traceId : this.api.traceId;
        },
        errorDate() {
            let date = "";
            if (this.mode === "sum") {
                date = this.convertAndFormatTimeToLocal(
                    this.processInspectorDescriptionById.errorDate,
                    APP_DATE_DOT_FORMAT
                );
            } else if (this.mode === "api") {
                date = this.convertAndFormatTimeToLocal(
                    this.api.errorDate,
                    APP_DATE_DOT_FORMAT
                );
            }
            return date;
        },
        showErrorInfo() {
            let show = false;
            if (
                (this.mode === "sum"
                    && this.processInspectorDescriptionById.systemStatus
                        === "Failed"
                    && !this.isArchiving)
                || (this.mode === "api" && this.api.error)
            ) {
                show = true;
            }
            return show;
        }
    },
    methods: {
        convertAndFormatTimeToLocal,
        downloadErrorCode,
        copyToClipboard,
        optionSelected(evt) {
            if (evt[0].value === "copy") {
                this.copyError();
            } else if (evt[0].value === "download") {
                this.downloadError();
            }
        },
        copyError() {
            if (this.mode === "sum") {
                this.copyToClipboard(
                    this.processInspectorDescriptionById.stackTrace
                );
            } else if (this.mode === "api") {
                this.copyToClipboard(this.api.error);
            }
        },
        downloadError() {
            if (this.mode === "sum") {
                this.downloadErrorCode(
                    this.processInspectorDescriptionById.stackTrace
                );
            } else if (this.mode === "api") {
                this.downloadErrorCode(this.api.error);
            }
        }
    }
};
